var _rect, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon4, _path8, _path9, _path10, _ellipse, _path11, _ellipse2, _g, _rect2, _ellipse3, _ellipse4, _ellipse5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrelim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 928 778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 761,
    y: 36,
    width: 13,
    height: 742,
    fill: "#C4C4D2",
    rx: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "648,50 900,50 928,92 900,134 648,134",
    fill: "#2e7d32"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "893,166 893,243 641,243 611,204 641,166",
    fill: "#D0D0DC"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "893,262 893,339 641,339 611,300 641,262",
    fill: "#D0D0DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 234,548            C 222,618 206,678 192,718            C 185,733 178,746 174,758            L 238,758            C 244,746 252,732 262,716            C 276,676 294,616 304,548 Z",
    fill: "#252538"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 164,758 C 146,766 138,776 145,778 L 248,778 L 248,758 Z",
    fill: "#14142A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 304,548            C 326,618 350,678 372,716            C 382,732 390,746 396,758            L 458,758            C 456,746 448,732 438,716            C 416,676 390,616 374,548 Z",
    fill: "#252538"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 394,758 L 394,778 L 474,778 C 482,776 480,764 462,758 Z",
    fill: "#14142A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 174,374            C 202,352 260,344 296,342            C 332,344 390,352 418,374            L 406,548            C 368,564 330,570 296,572            C 262,570 224,564 186,548 Z",
    fill: "#252538"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 272,346 L 296,360 L 320,346 L 320,362 L 296,380 L 272,362 Z",
    fill: "#EAEAF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 284,354 L 308,354 L 316,444 L 296,460 L 276,444 Z",
    fill: "#2e7d32"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "284,354 308,354 296,370",
    fill: "#245f26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 272,350 C 282,354 290,360 296,368 L 268,442 L 252,436 Z",
    fill: "#1C1C30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 320,350 C 310,354 302,360 296,368 L 324,442 L 340,436 Z",
    fill: "#1C1C30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 180,384            C 138,444 140,520 158,560            C 170,586 200,594 226,582            L 236,560            C 208,550 196,526 194,500            C 190,462 210,420 234,386 Z",
    fill: "#252538"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228,
    cy: 585,
    rx: 24,
    ry: 22,
    fill: "#F5A898"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 414,386            C 456,448 452,520 436,558            C 424,582 400,590 376,578            L 366,556            C 392,546 404,522 406,496            C 410,458 394,418 370,386 Z",
    fill: "#252538"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370,
    cy: 560,
    rx: 20,
    ry: 18,
    fill: "#F5A898"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(237,572) rotate(-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -122,
    y: -98,
    width: 248,
    height: 190,
    rx: 10,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82,
    y: -98,
    width: 42,
    height: 43,
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82,
    y: -12,
    width: 42,
    height: 43,
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: -55,
    width: 42,
    height: 43,
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 33,
    width: 42,
    height: 42,
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -98,
    width: 42,
    height: 90,
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: 33,
    width: 42,
    height: 42,
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82,
    y1: -98,
    x2: -82,
    y2: 92,
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: -98,
    x2: -40,
    y2: 92,
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: -98,
    x2: 4,
    y2: 92,
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: -98,
    x2: 48,
    y2: 92,
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: -98,
    x2: 92,
    y2: 92,
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -122,
    y1: -55,
    x2: 126,
    y2: -55,
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -122,
    y1: -12,
    x2: 126,
    y2: -12,
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -122,
    y1: 31,
    x2: 126,
    y2: 31,
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -122,
    y1: 74,
    x2: 126,
    y2: 74,
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -90,
    cy: -74,
    r: 6,
    fill: "#2e7d32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: -26,
    r: 27,
    fill: "#2e7d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20,-0 L 6,26 L 34,26 Z",
    fill: "#2e7d32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: -28,
    r: 12,
    fill: "white",
    opacity: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 326,
    width: 32,
    height: 20,
    fill: "#F5A898"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296,
    cy: 278,
    rx: 60,
    ry: 68,
    fill: "#F5A898"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296,
    cy: 244,
    rx: 60,
    ry: 40,
    fill: "#252538"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 237,
    cy: 286,
    rx: 12,
    ry: 18,
    fill: "#F5A898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrelim);
export default __webpack_public_path__ + "static/media/prelim.a123b3ec411e68036a2f9c7c20c1933b.svg";
export { ForwardRef as ReactComponent };